// extracted by mini-css-extract-plugin
export default {"page-button":"page_page-button__FSKzd","page-button-right":"page_page-button-right__T-Np9"};